var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:("primary-button" + (_vm._class ? (" " + _vm._class) : '')),on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.hasSlot)?_vm._t("default"):_c('span',{domProps:{"innerHTML":_vm._s(_vm.label)}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }